import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import CardHeader from '@material-ui/core/CardHeader';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import spinner from './images/spinner.gif';
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import './console.css';
import DEVICE_TYPE from '../enum/device_type';
import EVENT_CRUD_TYPES from '../common/event-crud-types';
import EVENT_TYPES from '../common/event-type';
import LOCATION_TYPE_ID from '../enum/location_type';
import CloseIcon from '@material-ui/icons/Close';
import Paper from '@material-ui/core/Paper';
import pendingIcon from '../iLocal-Delivery-Icons/Mail.svg';
import counterIcon from '../iLocal-Delivery-Icons/Counter.svg';
import kioskIcon from '../iLocal-Delivery-Icons/Kiosk.svg';
import curbsideIcon from '../iLocal-Delivery-Icons/Curbside.svg';
import courierIcon from '../iLocal-Delivery-Icons/Courier.svg';
import bedsideIcon from '../iLocal-Delivery-Icons/Bedside.svg';
import InfiniteScroll from 'react-infinite-scroll-component';
import ArrivedNotification from './notificationsound';
// import ChatScreen from './ChatScreen';
import AppBar from '@material-ui/core/AppBar';
import IconButton from '@material-ui/core/IconButton';
import AccountCircle from '@material-ui/icons/AccountCircle';
import Menu from '@material-ui/core/Menu';
import Toolbar from '@material-ui/core/Toolbar';
import Calendar from 'react-calendar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
// import ListItemIcon from '@material-ui/core/ListItemIcon';
// import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import 'react-calendar/dist/Calendar.css';
import Logo from './images/logo.png';
import PrintTemplate from 'react-print';
import LabelTemplate from './labelTemplate';

import io from 'socket.io-client';

const deliveryType = [
  { id: 'a5bd2ad0-0780-42cd-a270-7e76c4f20500', label: 'Kiosk' },
  { id: '93d79d62-523a-4d4f-851f-6866d38cb340', label: 'Courier' },
  { id: '40a40496-1c2a-4f46-b00a-f210d34f24cd', label: 'Curbside' },
  { id: '7e8e5632-6187-4d9b-9528-adf14825e859', label: 'InPatient' },
  { id: '567c43b9-dd50-4dd0-b293-2f8ebceb035c', label: 'Counter' },
];

const styles = (theme) => ({
  root: {
    width: '100%',
  },
  paper: {
    padding: theme.spacing.unit * 2,
    height: '100%',
    color: theme.palette.text.secondary,
  },
  spinner: {
    position: 'absolute',
    background: 'rgba(255,255,255,.4)',
    width: '100%',
    height: '100%',
    zIndex: '9999',
    top: 0,
    left: 0,
  },
  spinnerImage: {
    top: 'calc(50% - 32.5px)',
    left: 'calc(50% - 65px)',
    position: 'absolute',
    width: '130px',
    userSelect: 'none',
  },
  flex: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  demo: {
    backgroundColor: theme.palette.background.paper,
  },
  title: {
    margin: `${theme.spacing.unit * 4}px 0 ${theme.spacing.unit * 2}px`,
  },
  primaryButton: {
    background: '#6cca98',
    color: '#fff',
    '&:hover': {
      background: '#6cca98',
      color: '#fff',
    },
    '&:disabled': {
      color: 'rgba(0, 0, 0, 0.38)',
      cursor: 'not-allowed',
      background: '#E4E5E8'
    },
 }
});

class Console extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      page: 0,
      rowsPerPage: 10,
      pendingDelivery: [],
      kioskData: [],
      courierData: [],
      bedSideData: [],
      curbSideData: [],
      counterData: [],
      kioskPage: 0,
      counterPage: 0,
      courierPage: 0,
      bedsidePage: 0,
      curbsidePage: 0,
      searchText: '',
      scanText: '',
      loader: false,
      scanTextError: false,
      popupData: [],
      open_Move: false,
      fromType: '',
      toType: 'Kiosk',
      selectedTypeId: 'a5bd2ad0-0780-42cd-a270-7e76c4f20500',
      id: '',
      customer_id: '',
      box_id: '',
      pucode: '',
      disableMove: false,
      type_id: '',
      deletepopup: false,
      items: [],
      rowsPerPagePending: 10,
      rowPerPageCounter: 10,
      rowsPerPageCourier: 10,
      rowsPerPageCurbside: 10,
      rowPerPageInPatient: 10,
      rowPerPageInKiosk: 10,
      hasMore: true,
      hasMoreCounter: true,
      hasMoreKiosk: true,
      hasMoreCurbside: true,
      hasMoreCourier: true,
      hasMoreInpatient: true,
      totalCount: [],
      totalCountCounter: [],
      selectedDate: null,
      anchorEl: null,
      auth: true,
      blockInitialNotificationSound: true,
    };
  }

  initSocket = async () => {
    const user = sessionStorage.getItem('user');
    if (!this.socket && user) {
      /**
       ** Socket Initialization **
       */

      this.socket = io(
        `${process.env.REACT_APP_VIDEO_SOCKET_BASEURL}/console-socket`,
        {
          transports: ['websocket'],
          auth: {
            token: `Bearer ${
              JSON.parse(user).signInUserSession.idToken.jwtToken
            }`,
          },
          secure: true,
        }
      );

      /**
       ** Internal Socket Event **
       */

      this.socket &&
        this.socket.on('connect', () => {
          console.log('Socket connection established from PORTAL(ReConnect)');
        });
      this.socket &&
        this.socket.on('connect_error', (error) => {
          console.log('Connect Error: ', error);
          if (
            error.message === 'TokenExpiredError' ||
            error.message === 'JsonWebTokenError' ||
            error.message === 'NoTokenFound'
          ) {
            this.signOut();
          }
        });
      this.socket &&
        this.socket.on('connect_failed', (error) => {
          console.log('Connect Failed: ', error);
        });
      this.socket &&
        this.socket.on('error', (error) => {
          console.log('Error: ', error);
        });
      this.socket &&
        this.socket.on('disconnect', (reason) => {
          console.log(
            `Socket Disconnected From Portal and Reason is: ${reason}`
          );
        });

      /**
       ** Socket Console Event Starts **
       */
      this.socket &&
        this.socket.on('console', async (res) => {
          this.setState({
            counterData: [],
            pendingDelivery: [],
            kioskData: [],
            courierData: [],
            curbSideData: [],
            bedSideData: [],
          });
          await this.checkNotification(res.counter, 'totalCountCounter');
          await this.checkNotification(res.curbside, 'totalCount');
          this.setState({
            loader: false,
            counterData: res.counter,
            pendingDelivery: res.pendingDelivery,
            kioskData: res.kiosk,
            courierData: res.courier,
            curbSideData: res.curbside,
            bedSideData: res.bedside,
            blockInitialNotificationSound: false,
          });
        });

      this.socket &&
        this.socket.on('counter', async (res) => {
          this.setState({
            loader: false,
            counterData: res,
          });
          await this.checkNotification(res.counter, 'totalCountCounter');
        });

      this.socket &&
        this.socket.on('pendingDelivery', (res) => {
          this.setState({
            loader: false,
            pendingDelivery: res,
          });
        });

      this.socket &&
        this.socket.on('kiosk', (res) => {
          this.setState({
            loader: false,
            kioskData: res,
          });
        });

      this.socket &&
        this.socket.on('courier', (res) => {
          this.setState({
            loader: false,
            courierData: res,
          });
        });

      this.socket &&
        this.socket.on('curbside', async (res) => {
          this.setState({
            loader: false,
            curbSideData: res,
          });
          await this.checkNotification(res.curbside, 'totalCount');
        });

      this.socket &&
        this.socket.on('bedside', (res) => {
          this.setState({
            loader: false,
            bedSideData: res,
          });
        });
    }
  };

  checkNotification = async (res, type) => {
    if (this.state.blockInitialNotificationSound) {
      if (res && res.results && res.results.length > 0) {
        let arrivedData = res.results.filter(
          (val) => val.type_id === DEVICE_TYPE.Arrived
        );
        this.setState({ [type]: arrivedData });
      }
    } else {
      if (res && res.results && res.results.length > 0) {
        let arrivedData = res.results.filter(
          (val) => val.type_id === DEVICE_TYPE.Arrived
        );
        if (arrivedData.length > this.state[type].length) {
          this.setState({ [type]: arrivedData }, () => {
            this.playNotification();
          });
        }
      }
    }
  };

  async componentDidMount() {
    !this.socket && (await this.initSocket());
    this.consoleRequest = {
      pageNo: {
        pendingDelivery: 1,
        counter: 1,
        kiosk: 1,
        courier: 1,
        curbside: 1,
        bedside: 1,
      },
      pageSize: {
        pendingDelivery: 10,
        counter: 10,
        kiosk: 10,
        courier: 10,
        curbside: 10,
        bedside: 10,
      },
      scanText: '',
      searchText: '',
      sortColumn: 'created_on',
      sortOrder: 'desc',
      isKaktus: false,
    };
    console.log(`this.consoleRequest`, this.consoleRequest);
    this.socket &&
      this.socket.emit('getConsole', this.consoleRequest) &&
      this.setState({ loader: true });
  }

  componentWillUnmount() {
    clearInterval(this.interval);
    this.socket && this.socket.disconnect();
  }

  playNotification = () => {
    console.log('playNotification');
    // ArrivedNotification.play();
    //e.preventDefault();
    let sound = document.getElementById('curbSound');
    sound.play();
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleCloseMove = () => {
    this.setState({ open_Move: false });
  };

  handleMoveOpen = () => {
    console.log('handleMoveOpen');
    this.setState({
      open_Move: true,
      disableMove: true,
      selectedTypeId: 'a5bd2ad0-0780-42cd-a270-7e76c4f20500',
    });
  };

  handleOpen = (type, obj) => {
    this.setState({ type_id: obj.type_id });
    if (obj.locationtype_id === LOCATION_TYPE_ID.Kiosk) {
      this.setState({ selectedTypeId: LOCATION_TYPE_ID.Kiosk });
    } else if (obj.locationtype_id === LOCATION_TYPE_ID.Counter) {
      this.setState({ selectedTypeId: LOCATION_TYPE_ID.Counter });
    } else if (obj.locationtype_id === LOCATION_TYPE_ID.Courier) {
      this.setState({ selectedTypeId: LOCATION_TYPE_ID.Courier });
    } else if (obj.locationtype_id === LOCATION_TYPE_ID.Curbside) {
      this.setState({ selectedTypeId: LOCATION_TYPE_ID.Curbside });
    } else if (obj.locationtype_id === LOCATION_TYPE_ID.InPatient) {
      this.setState({ selectedTypeId: LOCATION_TYPE_ID.InPatient });
    }

    if (type === 'kiosk' || obj.DeliveryType === 'Kiosk') {
      this.setState({ disableMove: true });
    } else {
      this.setState({ disableMove: false });
    }
    this.setState({
      fromType: obj.DeliveryType,
      id: obj.id,
      customer_id: obj.customer_id,
      box_id: obj.box_id,
      pucode: obj.pucode,
      loader: true,
    });
    fetch(
      process.env.REACT_APP_BASEURL +
        `deliveryconsole/getdetailsByID/${obj.id}`,
      {
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
          'Content-Type': 'application/json',
        },
      }
    )
      .then((response) => response.json())
      .then((res) => {
        this.setState({ popupData: res }, () => {
          this.setState({ open: true, loader: false });
        });
      });
  };

  inputHandler = (type, value) => {
    this.setState({ [type]: value }, () => {
      console.log(
        this.state.searchText.length,
        this.state.searchText.length - 2
      );
      if (
        this.state.searchText.length > 1 ||
        this.state.searchText.length === 0
      ) {
        this.consoleRequest.searchText = this.state.searchText;
        this.socket && this.socket.emit('getConsole', this.consoleRequest);
      }
    });
  };

  scanHandler = (type, value) => {
    this.setState({ [type]: value }, () => {
      if (
        this.state.scanText.length === 6 ||
        this.state.scanText.length === 0
      ) {
        this.consoleRequest.scanText = this.state.scanText;
        this.socket && this.socket.emit('getConsole', this.consoleRequest);
      }
      if (this.state.scanText.length > 6) {
        this.setState({ scanTextError: true });
      } else {
        this.setState({ scanTextError: false });
      }
    });
  };

  onChangeDeliveyType = (event) => {
    this.setState({ selectedTypeId: event.target.value }, () => {
      let label = deliveryType.filter((val) => {
        if (val.id === this.state.selectedTypeId) {
          return val.label;
        }
        return '';
      });
      this.setState({ toType: label });
      if (
        this.state.selectedTypeId === 'a5bd2ad0-0780-42cd-a270-7e76c4f20500'
      ) {
        this.setState({ disableMove: true });
      } else {
        this.setState({ disableMove: false });
      }
    });
  };

  moveHandler = (type) => {
    this.setState({ loader: true, open_Move: false, open: false });
    let object_id = '';
    let event_type_name = '';
    let type_id = '';
    if (type === 'move') {
      object_id = DEVICE_TYPE.Move;
      event_type_name = EVENT_TYPES.MOVE;
      type_id = this.state.type_id;
    } else if (type === 'deliver') {
      object_id = DEVICE_TYPE.Out_for_Delivery;
      event_type_name = EVENT_TYPES.Out_for_Delivery;
      type_id = object_id;
    } else if (type === 'complete') {
      object_id = DEVICE_TYPE.Completed;
      event_type_name = EVENT_TYPES.COMPLETE;
      type_id = object_id;
    } else if (type === 'return') {
      object_id = DEVICE_TYPE.Returned;
      event_type_name = EVENT_TYPES.RETURN;
      type_id = object_id;
    } else if (type === 'cancel') {
      object_id = DEVICE_TYPE.Cancelled;
      event_type_name = EVENT_TYPES.CANCEL;
      type_id = object_id;
    }
    let user = JSON.parse(sessionStorage.getItem('user'));
    let token =
      user &&
      user.signInUserSession &&
      user.signInUserSession.idToken &&
      user.signInUserSession.idToken.jwtToken;
    const event_params = {
      event_name: EVENT_CRUD_TYPES.INSERT,
      event_type_name: event_type_name,
      description: `Prescription is moved from ${this.state.fromType} to ${this.state.toType} with pickup code ${this.state.pucode}`,
      object_id: object_id,
      tofor_id: this.state.id,
      box_id: this.state.box_id,
      authorization: token,
      customer_id: this.state.customer_id,
      location_type_id: this.state.selectedTypeId,
      type_id: type_id,
      pickup_date:
        this.state.popupData !== '' &&
        this.state.popupData !== undefined &&
        this.state.popupData !== 'undefined'
          ? this.state.popupData.pickup_date
          : new Date(),
      order_id:
        this.state.popupData !== '' &&
        this.state.popupData !== undefined &&
        this.state.popupData !== 'undefined'
          ? this.state.popupData.id
          : '',
      account_id:
        this.state.popupData !== '' &&
        this.state.popupData !== undefined &&
        this.state.popupData !== 'undefined'
          ? this.state.popupData.parent_account_id
          : '',
      location_notes:
        this.state.popupData !== '' &&
        this.state.popupData !== undefined &&
        this.state.popupData !== 'undefined'
          ? this.state.popupData.present_location
          : '',
    };
    fetch(process.env.REACT_APP_BASEURL + `deliveryconsole/updatestatus`, {
      method: 'POST',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(event_params),
    })
      .then((response) => response.json())
      .then((res) => {
        this.setState({ loader: false }, () => {
          this.socket && this.socket.emit('getConsole', this.consoleRequest);
        });
      });
  };

  handleCloseCancel = () => {
    this.setState({ deletepopup: false });
  };

  cancelHandler = () => {
    this.setState({ deletepopup: true });
  };

  cancelHandlerOrder = () => {
    this.setState({ deletepopup: false, open: false });
    this.moveHandler('cancel');
  };

  fetchMoreData = (type) => {
    if (type === 'pending') {
      let total = 0;
      total =
        this.state &&
        this.state.pendingDelivery &&
        this.state.pendingDelivery.results &&
        this.state.pendingDelivery.results.length;
      if (
        total > 0 &&
        this.state.pendingDelivery.results.length <
          this.state.pendingDelivery.total
      ) {
        this.setState({ total: this.state.total + total });
        this.setState(
          { rowsPerPagePending: this.state.rowsPerPagePending + 10 },
          () => {
            this.consoleRequest.pageSize.pendingDelivery = this.state.rowsPerPagePending;
            this.socket &&
              this.socket.emit('getPendingDelivery', this.consoleRequest);
          }
        );
      } else {
        this.setState({ hasMore: false });
      }
    } else if (type === 'counter') {
      let total = 0;
      total =
        this.state &&
        this.state.counterData &&
        this.state.counterData.results &&
        this.state.counterData.results.length;
      if (
        total > 0 &&
        this.state.counterData.results.length < this.state.counterData.total
      ) {
        this.setState(
          { rowPerPageCounter: this.state.rowPerPageCounter + 10 },
          () => {
            this.consoleRequest.pageSize.counter = this.state.rowPerPageCounter;
            this.socket && this.socket.emit('getCounter', this.consoleRequest);
          }
        );
      } else {
        this.setState({ hasMoreCounter: false });
      }
    } else if (type === 'kiosk') {
      let total = 0;
      total =
        this.state &&
        this.state.kioskData &&
        this.state.kioskData.results &&
        this.state.kioskData.results.length;
      if (
        total > 0 &&
        this.state.kioskData.results.length < this.state.kioskData.total
      ) {
        this.setState(
          { rowPerPageInKiosk: this.state.rowPerPageInKiosk + 10 },
          () => {
            this.consoleRequest.pageSize.kiosk = this.state.rowPerPageInKiosk;
            this.socket && this.socket.emit('getKiosk', this.consoleRequest);
          }
        );
      } else {
        this.setState({ hasMoreKiosk: false });
      }
    } else if (type === 'curbside') {
      let total = 0;
      total =
        this.state &&
        this.state.curbSideData &&
        this.state.curbSideData.results &&
        this.state.curbSideData.results.length;
      if (
        total > 0 &&
        this.state.curbSideData.results.length < this.state.curbSideData.total
      ) {
        this.setState(
          { rowsPerPageCurbside: this.state.rowsPerPageCurbside + 10 },
          () => {
            this.consoleRequest.pageSize.curbside = this.state.rowsPerPageCurbside;
            this.socket && this.socket.emit('getCurbside', this.consoleRequest);
          }
        );
      } else {
        this.setState({ hasMoreCurbside: false });
      }
    } else if (type === 'courier') {
      let total = 0;
      total =
        this.state &&
        this.state.courierData &&
        this.state.courierData.results &&
        this.state.courierData.results.length;
      if (
        total > 0 &&
        this.state.courierData.results.length < this.state.courierData.total
      ) {
        this.setState(
          { rowsPerPageCourier: this.state.rowsPerPageCourier + 10 },
          () => {
            this.consoleRequest.pageSize.courier = this.state.rowsPerPageCourier;
            this.socket && this.socket.emit('getCourier', this.consoleRequest);
          }
        );
      } else {
        this.setState({ hasMoreCourier: false });
      }
    } else if (type === 'inpatient') {
      let total = 0;
      total =
        this.state &&
        this.state.bedSideData &&
        this.state.bedSideData.results &&
        this.state.bedSideData.results.length;
      if (
        total > 0 &&
        this.state.bedSideData.results.length < this.state.bedSideData.total
      ) {
        this.setState(
          { rowPerPageInPatient: this.state.rowPerPageInPatient + 10 },
          () => {
            this.consoleRequest.pageSize.bedside = this.state.rowPerPageInPatient;
            this.socket && this.socket.emit('getBedside', this.consoleRequest);
          }
        );
      } else {
        this.setState({ hasMoreInpatient: false });
      }
    }
  };

  printTemplete = async () => {
    this.setState({ open: false });
    setTimeout(async () => {
      window.print();
    }, 100);
  };

  handleMenu = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleCloseMenu = () => {
    window.location.href = `/`;
    this.setState({ anchorEl: null });
  };

  reminderHandler = () => {
    this.setState({ open: false, loader: true });
    let data = {
      order_id: this.state.popupData.id,
      account_id: this.state.popupData.parent_account_id,
      location_type_id: this.state.popupData.locationtype_id,
    };

    fetch(process.env.REACT_APP_BASEURL + 'delivery/remindnotification', {
      method: 'POST',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((res) => {
        this.setState({ loader: false }, () => {
          this.socket && this.socket.emit('getConsole', this.consoleRequest);
        });
      })
      .catch((error) => {
        console.log('error', error);
        this.setState({ loader: false });
      });
  };

  RenderAmountLayout = () => {
    const { popupData } = this.state;
    const style = {color: 'rgba(0, 0, 0, 0.54)', fontSize: '0.75rem', fontWeight: 500, textAlign: 'right', borderBottom: 'none', padding: '4px 25px 4px 24px !important', width: '80%'}
    return(
      <div>
        <Table aria-labelledby="tableTitle">
          <TableRow style={{ height: 40 }}>
             <TableCell style={style}>Paid</TableCell>
             <TableCell style={{ textAlign: 'left' }}>
                {popupData && popupData.amount && popupData.amount.isPaid === true ? popupData && popupData.amount && popupData.amount.Total : popupData && popupData.amount && popupData.amount.Paid}
            </TableCell>
          </TableRow>
          <TableRow style={{ height: 40 }}>
             <TableCell style={style}>Amount Due</TableCell>
             <TableCell style={{ textAlign: 'left' }}>
                {popupData && popupData.amount && popupData.amount.Due}
            </TableCell>
          </TableRow>
          <TableRow style={{ height: 40 }}>
             <TableCell style={style}>Amount Total</TableCell>
             <TableCell style={{ textAlign: 'left' }}>
                {popupData && popupData.amount && popupData.amount.Total}
            </TableCell>
          </TableRow>
        </Table>
      </div>
    )
  };

  render() {
    const { classes } = this.props;
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);
    let deletepopup = (
      <div>
        <Dialog
          fullWidth={true}
          maxWidth={'xs'}
          open={this.state.deletepopup}
          onClose={this.handleCloseCancel}>
          <DialogTitle id='scroll-dialog-title'>
            <span style={{ color: '#423e3e', fontSize: '1.1rem' }}>
              Are you sure you want to cancel this order? This will remove it
              from the console completely.
            </span>
          </DialogTitle>
          <DialogContent>
            <div style={{ display: 'flex', justifyContent: 'space-between'}}>
              <Button color='primary' onClick={() => this.cancelHandlerOrder()} className={classes.primaryButton}>
                Yes
              </Button>
              <Button color='primary' onClick={() => this.handleCloseCancel()} className={classes.primaryButton}>
                No
              </Button>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    );

    let popup = (
      <div>
        <Dialog
          fullWidth={true}
          maxWidth={'md'}
          open={this.state.open}
          onClose={this.handleClose}>
          <DialogTitle id='scroll-dialog-title' style={{ textAlign: 'center' }}>
            <span>Take Action</span>
            <span className='close-button' onClick={this.handleClose}>
              <CloseIcon />
            </span>
          </DialogTitle>
          <DialogContent>
            {this.state.popupData !== '' &&
            this.state.popupData !== undefined &&
            this.state.popupData !== 'undefined' ? (
              <Grid container>
                <Grid item xs={3} className='font-style'>
                  Pickup Code
                </Grid>
                <Grid item xs={3}>
                  {this.state.popupData !== '' &&
                    this.state.popupData !== undefined &&
                    this.state.popupData !== 'undefined' &&
                    this.state.popupData.pucode}
                </Grid>
                <Grid item xs={3} className='font-style'>
                  Patient Name
                </Grid>
                <Grid item xs={3}>
                  {this.state.popupData !== '' &&
                    this.state.popupData !== undefined &&
                    this.state.popupData !== 'undefined' &&
                    this.state.popupData.first_name +
                      ' ' +
                      this.state.popupData.last_name}
                </Grid>
                <br />
                <br />
                <Grid item xs={3} className='font-style'>
                  Phone Number
                </Grid>
                <Grid item xs={3}>
                  {this.state.popupData !== '' &&
                    this.state.popupData !== undefined &&
                    this.state.popupData !== 'undefined' &&
                    this.state.popupData.phone}
                </Grid>
                <Grid item xs={3} className='font-style'>
                  Email
                </Grid>
                <Grid item xs={3}>
                  {this.state.popupData !== '' &&
                    this.state.popupData !== undefined &&
                    this.state.popupData !== 'undefined' &&
                    this.state.popupData.email}
                </Grid>
                <br />
                <br />

                <Grid item xs={3} className='font-style'>
                  Storage Location
                </Grid>
                <Grid item xs={3}>
                  {this.state.popupData !== '' &&
                    this.state.popupData !== undefined &&
                    this.state.popupData !== 'undefined' &&
                    this.state.popupData.storage_location}
                </Grid>
                <Grid item xs={3} className='font-style'>
                  Location Notes
                </Grid>
                <Grid item xs={3}>
                  {this.state.popupData !== '' &&
                    this.state.popupData !== undefined &&
                    this.state.popupData !== 'undefined' &&
                    this.state.popupData.location_notes}
                </Grid>
                <br />
                <br />

                <Grid item xs={3} className='font-style'>
                  Patient Notes
                </Grid>
                <Grid item xs={3}>
                  {this.state.popupData !== '' &&
                    this.state.popupData !== undefined &&
                    this.state.popupData !== 'undefined' &&
                    this.state.popupData.patient_notes}
                </Grid>
                <Grid item xs={3} className='font-style'>
                  Order Notes
                </Grid>
                <Grid item xs={3}>
                  {this.state.popupData !== '' &&
                    this.state.popupData !== undefined &&
                    this.state.popupData !== 'undefined' &&
                    this.state.popupData.order_notes}
                </Grid>
                <br />
                <br />
                {this.state.popupData !== '' &&
                this.state.popupData.present_location !== null &&
                this.state.popupData.present_location !== 'null' &&
                this.state.popupData.present_location !== undefined &&
                this.state.popupData.present_location !== 'undefined' ? (
                  <Grid container>
                    <Grid item xs={3} className='font-style'>
                      Patient Order Notes
                    </Grid>
                    <Grid item xs={3}>
                      {this.state.popupData.present_location}
                    </Grid>
                    <Grid item xs={3} className='font-style'>
                      Signature
                    </Grid>
                    <Grid item xs={3}>
                      {this.state.popupData !== '' &&
                      this.state.popupData !== undefined &&
                      this.state.popupData !== 'undefined' &&
                      this.state.popupData.signature_url ? (
                        <img
                          src={this.state.popupData.signature_url}
                          alt='noimage'
                          style={{ width: '100px' }}
                        />
                      ) : (
                        ''
                      )}
                    </Grid>
                  </Grid>
                ) : (
                  ''
                )}
                <br />
                <br />
                <Grid item xs={3} className='font-style'>
                  Stock Code
                </Grid>
                <Grid item xs={3}>
                  {this.state.popupData !== '' &&
                    this.state.popupData !== undefined &&
                    this.state.popupData !== 'undefined' &&
                    this.state.popupData.stock_code}
                </Grid>
              </Grid>
            ) : (
              ''
            )}
            <br />
            <br />
            <Table class='fixed_headers'>
              <TableHead className='thead'>
                <TableRow className='row-height'>
                  <TableCell className='remove-padding'>Rx Number</TableCell>
                  <TableCell className='remove-padding' align='left'>
                    Drug Name
                  </TableCell>
                  <TableCell className='remove-padding' align='left'>
                    NDC Code
                  </TableCell>
                  <TableCell className='remove-padding' align='left'>
                    Amount
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody className='tbody' style={{ height: '0px' }}>
                {this.state.popupData !== null &&
                this.state.popupData !== '' &&
                this.state.popupData !== undefined &&
                this.state.popupData !== 'undefined'
                  ? this.state.popupData.items &&
                    this.state.popupData.items.length > 0 &&
                    this.state.popupData.items.map((val) => {
                      return (
                        <TableRow key={val.id} className='row-height'>
                          <TableCell
                            component='th'
                            scope='row'
                            className='remove-padding'>
                            {val.rx_no}
                          </TableCell>
                          <TableCell className='remove-padding' align='left'>
                            {val.drug_name}
                          </TableCell>
                          <TableCell className='remove-padding' align='left'>
                            {val.ndc_code}
                          </TableCell>
                          <TableCell className='remove-padding' align='left'>
                            {'$' + val.price + '.00'}
                          </TableCell>
                        </TableRow>
                      );
                    })
                  : ''}
              </TableBody>
            </Table>
            <br />
            {this.RenderAmountLayout()}
            <div  style={{ marginTop: '2%' }}>
              <Grid container style={{ justifyContent: 'space-evenly' }}>
                <Button color='primary' onClick={() => this.printTemplete()}
                className={classes.primaryButton}>
                  Print
                </Button>
                <Button
                  color='primary'
                  onClick={() => this.reminderHandler('deliver')}
                  disabled={this.state.disableMove}
                  className={classes.primaryButton}>
                  Remind
                </Button>
                <Button
                  color='primary'
                  onClick={() => this.moveHandler('deliver')}
                  className={classes.primaryButton}
                  disabled={this.state.disableMove}>
                  Deliver
                </Button>
                <Button
                  color='primary'
                  onClick={() => this.moveHandler('complete')}
                  className={classes.primaryButton}
                  disabled={this.state.disableMove}>
                  Complete
                </Button>
                <Button
                  color='primary'
                  onClick={() => this.moveHandler('return')}
                  className={classes.primaryButton}
                  disabled={this.state.disableMove}>
                  Return
                </Button>
                <Button
                  color='primary'
                  onClick={() => this.handleMoveOpen()}
                  disabled={this.state.disableMove}
                  className={classes.primaryButton}>
                  Move
                </Button>
                <Button color='primary' onClick={() => this.cancelHandler()}
                 className={classes.primaryButton}
                 disabled={this.state.disableMove}>
                  Cancel
                </Button>
              </Grid>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    );

    let movePopup = (
      <div>
        <Dialog
          fullWidth={true}
          maxWidth={'sm'}
          open={this.state.open_Move}
          onClose={this.handleCloseMove}>
          <DialogTitle id='scroll-dialog-title' style={{ textAlign: 'center' }}>
            <span>Move Action</span>
            <span className='close-button' onClick={this.handleCloseMove}>
              <CloseIcon />
            </span>
          </DialogTitle>
          <DialogContent>
            {this.state.popupData !== '' &&
            this.state.popupData !== undefined &&
            this.state.popupData !== 'undefined' ? (
              <Grid container>
                <Grid item xs={3} className='font-style'>
                  Pickup Code
                </Grid>
                <Grid item xs={3}>
                  {this.state.popupData !== '' &&
                    this.state.popupData !== undefined &&
                    this.state.popupData !== 'undefined' &&
                    this.state.popupData.pucode}
                </Grid>
                <Grid item xs={3} className='font-style'>
                  Name
                </Grid>
                <Grid item xs={3}>
                  {this.state.popupData !== '' &&
                    this.state.popupData !== undefined &&
                    this.state.popupData !== 'undefined' &&
                    this.state.popupData.first_name +
                      ' ' +
                      this.state.popupData.last_name}
                </Grid>
              </Grid>
            ) : (
              ''
            )}
            <div className={classes.root}>
              {this.state.loader ? (
                <div className={classes.spinner}>
                  <img
                    className={classes.spinnerImage}
                    src={spinner}
                    alt='loading'
                  />
                </div>
              ) : null}
            </div>
            <br />
            <br />
            <Table class='fixed_headers'>
              <TableHead className='thead'>
                <TableRow className='row-height'>
                  <TableCell className='remove-padding'>From</TableCell>
                  <TableCell className='remove-padding' align='right'>
                    To
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody className='tbody'>
                <TableRow className='row-height'>
                  <TableCell
                    component='th'
                    scope='row'
                    className='remove-padding'>
                    {this.state.fromType}
                  </TableCell>
                  <TableCell>
                    <FormControl>
                      <Select
                        value={this.state.selectedTypeId}
                        onChange={(event) => this.onChangeDeliveyType(event)}>
                        {deliveryType.map((box, index) => (
                          <MenuItem key={index} value={box.id} selected>
                            {box.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
            <br />
            <Grid container style={{ display: 'flex', justifyContent: 'space-between'}}>
              <Button
                color='primary'
                onClick={() => this.moveHandler('move')}
                disabled={this.state.disableMove}
                className={classes.primaryButton}>
                Move
              </Button>
              <Button onClick={this.handleCloseMove} color='primary'
              className={classes.primaryButton}>
                Close
              </Button>
            </Grid>
          </DialogContent>
        </Dialog>
      </div>
    );

    return (
      <div>
       <div id='react-no-print'>
        <AppBar position='fixed' style={{ backgroundColor: '#04A6E1' }}>
          <Toolbar style={{ paddingLeft: 0 }}>
            <div>
              <img
                src={Logo}
                alt='Kaktus Logo'
                style={{ height: 70, width: 150 }}
              />
            </div>
            <div style={{ width: '84%' }}>&nbsp;</div>
            <div>
              <IconButton
                aria-label='account of current user'
                aria-controls='menu-appbar'
                aria-haspopup='true'
                onClick={this.handleMenu}
                color='inherit'>
                <AccountCircle />
              </IconButton>
              <div style={{ position: 'absolute', top: '45%', right: '1%' }}>
                {JSON.parse(sessionStorage.getItem('user')) &&
                JSON.parse(sessionStorage.getItem('user')).signInUserSession ? (
                  <span style={{ textAlign: 'left' }}>
                    <span style={{ fontSize: 14 }}>
                      {
                        JSON.parse(sessionStorage.getItem('user'))
                          .signInUserSession.idToken.payload.name
                      }
                    </span>
                    <p style={{ marginTop: '-35px', fontSize: 14 }}>
                      {sessionStorage.getItem('parentAccountName')}
                    </p>
                  </span>
                ) : (
                  setTimeout(
                    () => this.props.navigate('/', { replace: true }),
                    0
                  )
                )}
              </div>
              <Menu
                id='menu-appbar'
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={open}
                onClose={this.handleCloseMenu}>
                <MenuItem onClick={this.handleCloseMenu}>Logout</MenuItem>
              </Menu>
            </div>
          </Toolbar>
        </AppBar>
        <div style={{ padding: '15px', marginTop: '4%' }}>
          <div id='react-no-print'>
            {popup}
            {movePopup}
            {deletepopup}
            <ArrivedNotification />
            <div className={classes.root}>
              {this.state.loader ? (
                <div className={classes.spinner}>
                  <img
                    className={classes.spinnerImage}
                    src={spinner}
                    alt='loading'
                  />
                </div>
              ) : null}
            </div>
            <Grid container className='search-pos'>
              <Grid item xs={4}>
                <TextField
                  label='Search'
                  className='text-width'
                  onChange={(event) =>
                    this.inputHandler('searchText', event.target.value)
                  }
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  label='Scan'
                  className='text-width'
                  error={this.state.scanTextError}
                  helperText={
                    this.state.scanTextError
                      ? 'Please Enter Valid stock code'
                      : ''
                  }
                  onChange={(event) =>
                    this.scanHandler('scanText', event.target.value)
                  }
                />
              </Grid>
            </Grid>
            <Grid container xs={12}>
              <Grid item xs={9}>
                <Grid
                  container
                  spacing={8}
                  style={{ marginBottom: '5px' }}
                  alignItems='center'
                  direction='row'
                  justify='end'>
                  {this.state.pendingDelivery &&
                  this.state.pendingDelivery.total > 0 ? (
                    <Grid item xs={4} style={{ paddingRight: '10px' }}>
                      <Paper className={classes.paper}>
                        <div>
                          <Grid container>
                            <Grid item xs={8}>
                              <span className='pending'>
                                Pending Deliveries
                              </span>
                            </Grid>
                            <Grid item xs={2}>
                              <img
                                src={pendingIcon}
                                alt='Icon'
                                className='pendingIcon'
                              />
                            </Grid>
                            <Grid item xs={2} className='count-position'>
                              <CardHeader
                                title={
                                  this.state.pendingDelivery &&
                                  this.state.pendingDelivery.total > 0
                                    ? this.state.pendingDelivery.total
                                    : 0
                                }
                              />
                            </Grid>
                          </Grid>
                          <div style={{ overflow: 'auto' }}>
                            <Table class='fixed_headers'>
                              <TableHead className='thead'>
                                <TableRow className='row-height'>
                                  <TableCell className='remove-padding full-name'>
                                    Full Name
                                  </TableCell>
                                  <TableCell className='remove-padding'>
                                    PU Code
                                  </TableCell>
                                  <TableCell className='remove-padding'>
                                    Delivery Type
                                  </TableCell>
                                  <TableCell className='remove-padding'>
                                    Destination Location
                                  </TableCell>
                                  <TableCell className='remove-padding'>
                                    Status
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                            </Table>
                            {this.state.pendingDelivery &&
                            this.state.pendingDelivery.total > 0 ? (
                              <div
                                scrollableTarget='scrollableDiv'
                                className='card-height'>
                                <InfiniteScroll
                                  dataLength={this.state.rowsPerPagePending}
                                  next={() => this.fetchMoreData('pending')}
                                  hasMore={this.state.hasMore}
                                  height={250}
                                  endMessage={
                                    <p style={{ textAlign: 'center' }}>
                                      <b>Yay! You have seen it all</b>
                                    </p>
                                  }>
                                  <Table style={{ tableLayout: 'fixed' }}>
                                    <TableBody className='tbody' style={{ height: '0px' }}>
                                      {this.state.pendingDelivery &&
                                      this.state.pendingDelivery.results
                                        ? this.state.pendingDelivery.results.map(
                                            (val) => {
                                              return (
                                                <TableRow
                                                  key={val.id}
                                                  className='row-height'>
                                                  <TableCell
                                                    component='th'
                                                    scope='row'
                                                    className='remove-padding'>
                                                    {val.first_name +
                                                      ' ' +
                                                      val.last_name}
                                                  </TableCell>
                                                  <TableCell
                                                    className='remove-padding pucode'
                                                    align='right'
                                                    onClick={() =>
                                                      this.handleOpen(
                                                        'pending',
                                                        val
                                                      )
                                                    }>
                                                    {val.pucode}
                                                  </TableCell>
                                                  <TableCell
                                                    className='remove-padding'
                                                    align='right'>
                                                    {val.DeliveryType}
                                                  </TableCell>
                                                  <TableCell
                                                    className='remove-padding'
                                                    align='right'>
                                                    {val.destination_location}
                                                  </TableCell>
                                                  <TableCell
                                                    className='remove-padding'
                                                    align='right'>
                                                    {val.type_id ===
                                                    DEVICE_TYPE.Ready
                                                      ? 'Ready'
                                                      : val.type_id ===
                                                        DEVICE_TYPE.Out_for_Delivery
                                                      ? 'Out for Delivery'
                                                      : val.type_id ===
                                                        DEVICE_TYPE.Arrived
                                                      ? 'Arrived'
                                                      : val.type_id ===
                                                        DEVICE_TYPE.Stocked
                                                      ? 'Stocked'
                                                      : val.type_id ===
                                                        DEVICE_TYPE.Return
                                                      ? 'Return'
                                                      : val.type_id ===
                                                        DEVICE_TYPE.Cancelled
                                                      ? 'Cancelled'
                                                      : val.type_id ===
                                                        DEVICE_TYPE.Completed
                                                      ? 'Completed'
                                                      : val.type_id ===
                                                        DEVICE_TYPE.Assigned
                                                      ? 'Assigned'
                                                      : ''}
                                                  </TableCell>
                                                </TableRow>
                                              );
                                            }
                                          )
                                        : ''}
                                    </TableBody>
                                  </Table>
                                </InfiniteScroll>
                              </div>
                            ) : (
                              <div
                                container
                                className='card-height noDataFound'>
                                <span>No Data Found</span>
                              </div>
                            )}
                          </div>
                        </div>
                      </Paper>
                    </Grid>
                  ) : (
                    ''
                  )}
                  {this.state.counterData &&
                  this.state.counterData.total > 0 ? (
                    <Grid
                      item
                      xs={4}
                      style={{ paddingRight: '10px', paddingLeft: '10px' }}>
                      <Paper className={classes.paper}>
                        <div>
                          <Grid container>
                            <Grid item xs={8}>
                              <span className='pending counter'>Counter</span>
                            </Grid>
                            <Grid item xs={2}>
                              <img
                                src={counterIcon}
                                alt='Icon'
                                className='pendingIcon'
                              />
                            </Grid>
                            <Grid item xs={2} className='count-position'>
                              <CardHeader
                                title={
                                  this.state.counterData &&
                                  this.state.counterData.total > 0
                                    ? this.state.counterData.total
                                    : 0
                                }
                              />
                            </Grid>
                          </Grid>
                          <div style={{ overflow: 'auto' }}>
                            <Table class='fixed_headers'>
                              <TableHead className='thead'>
                                <TableRow className='row-height'>
                                  <TableCell className='remove-padding full-name'>
                                    Full Name
                                  </TableCell>
                                  <TableCell
                                    className='remove-padding'
                                    align='right'>
                                    PU Code
                                  </TableCell>
                                  <TableCell
                                    className='remove-padding'
                                    align='right'>
                                    Location Notes
                                  </TableCell>
                                  <TableCell
                                    className='remove-padding'
                                    align='right'>
                                    Shelf
                                  </TableCell>
                                  <TableCell
                                    className='remove-padding'
                                    align='right'>
                                    Status
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                            </Table>
                            {this.state.counterData &&
                            this.state.counterData.total > 0 ? (
                              <div
                                scrollableTarget='scrollableDiv'
                                className='card-height'>
                                <InfiniteScroll
                                  dataLength={this.state.rowPerPageCounter}
                                  next={() => this.fetchMoreData('counter')}
                                  hasMore={this.state.hasMoreCounter}
                                  height={250}
                                  endMessage={
                                    <p style={{ textAlign: 'center' }}>
                                      <b>Yay! You have seen it all</b>
                                    </p>
                                  }>
                                  <Table style={{ tableLayout: 'fixed' }}>
                                    <TableBody
                                      className='tbody'
                                      style={{ height: '0px' }}>
                                      {this.state.counterData &&
                                      this.state.counterData.results
                                        ? this.state.counterData.results.map(
                                            (val) => {
                                              let color =
                                                val.type_id &&
                                                val.type_id ===
                                                  DEVICE_TYPE.Arrived
                                                  ? `style-row-counter`
                                                  : '';
                                              return (
                                                <TableRow
                                                  key={val.id}
                                                  className={`row-height ${color}`}>
                                                  <TableCell
                                                    component='th'
                                                    scope='row'
                                                    className='remove-padding'>
                                                    {val.first_name +
                                                      ' ' +
                                                      val.last_name}
                                                  </TableCell>
                                                  <TableCell
                                                    className='remove-padding pucode'
                                                    align='right'
                                                    onClick={() =>
                                                      this.handleOpen(
                                                        'counter',
                                                        val
                                                      )
                                                    }>
                                                    {val.pucode}
                                                  </TableCell>
                                                  <TableCell
                                                    className='remove-padding'
                                                    align='right'>
                                                    {val.notes}
                                                  </TableCell>
                                                  <TableCell
                                                    className='remove-padding'
                                                    align='right'>
                                                    {val.shelf}
                                                  </TableCell>
                                                  <TableCell
                                                    className='remove-padding'
                                                    align='right'>
                                                    {val.type_id ===
                                                    DEVICE_TYPE.Ready
                                                      ? 'Ready'
                                                      : val.type_id ===
                                                        DEVICE_TYPE.Out_for_Delivery
                                                      ? 'Out for Delivery'
                                                      : val.type_id ===
                                                        DEVICE_TYPE.Arrived
                                                      ? 'Arrived'
                                                      : val.type_id ===
                                                        DEVICE_TYPE.Stocked
                                                      ? 'Stocked'
                                                      : val.type_id ===
                                                        DEVICE_TYPE.Return
                                                      ? 'Return'
                                                      : val.type_id ===
                                                        DEVICE_TYPE.Cancelled
                                                      ? 'Cancelled'
                                                      : val.type_id ===
                                                        DEVICE_TYPE.Completed
                                                      ? 'Completed'
                                                      : ''}
                                                  </TableCell>
                                                </TableRow>
                                              );
                                            }
                                          )
                                        : ''}
                                    </TableBody>
                                  </Table>
                                </InfiniteScroll>
                              </div>
                            ) : (
                              <div
                                container
                                className='card-height noDataFound'>
                                <span>No Data Found</span>
                              </div>
                            )}
                          </div>
                        </div>
                      </Paper>
                    </Grid>
                  ) : (
                    ''
                  )}
                  {this.state.kioskData && this.state.kioskData.total > 0 ? (
                    <Grid
                      item
                      xs={4}
                      style={{ paddingRight: '10px', paddingLeft: '10px' }}>
                      <Paper className={classes.paper}>
                        <div>
                          <Grid container>
                            <Grid item xs={8}>
                              <span className='pending kiosk'>Kiosk</span>
                            </Grid>
                            <Grid item xs={2}>
                              <img
                                src={kioskIcon}
                                alt='Icon'
                                className='pendingIcon'
                              />
                            </Grid>
                            <Grid item xs={2} className='count-position'>
                              <CardHeader
                                title={
                                  this.state.kioskData &&
                                  this.state.kioskData.total > 0
                                    ? this.state.kioskData.total
                                    : 0
                                }
                              />
                            </Grid>
                          </Grid>
                          <div style={{ overflow: 'auto' }}>
                            <Table class='fixed_headers'>
                              <TableHead className='thead'>
                                <TableRow className='row-height'>
                                  <TableCell className='remove-padding full-name'>
                                    Full Name
                                  </TableCell>
                                  <TableCell
                                    className='remove-padding'
                                    align='right'>
                                    PU Code
                                  </TableCell>
                                  <TableCell
                                    className='remove-padding full-name'
                                    align='right'>
                                    Box Name
                                  </TableCell>
                                  <TableCell
                                    className='remove-padding'
                                    align='right'>
                                    Stock Code
                                  </TableCell>
                                  <TableCell
                                    className='remove-padding'
                                    align='right'>
                                    Status
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                            </Table>
                            {this.state.kioskData &&
                            this.state.kioskData.total > 0 ? (
                              <div
                                scrollableTarget='scrollableDiv'
                                className='card-height'>
                                <InfiniteScroll
                                  dataLength={this.state.rowPerPageInKiosk}
                                  next={() => this.fetchMoreData('kiosk')}
                                  hasMore={this.state.hasMoreKiosk}
                                  height={250}
                                  endMessage={
                                    <p style={{ textAlign: 'center' }}>
                                      <b>Yay! You have seen it all</b>
                                    </p>
                                  }>
                                  <Table style={{ tableLayout: 'fixed' }}>
                                    <TableBody className='tbody' style={{ height: '0px' }}>
                                      {this.state.kioskData &&
                                      this.state.kioskData.results
                                        ? this.state.kioskData.results.map(
                                            (val) => {
                                              return (
                                                <TableRow
                                                  key={val.id}
                                                  className='row-height'>
                                                  <TableCell
                                                    component='th'
                                                    scope='row'
                                                    className='remove-padding'>
                                                    {val.first_name +
                                                      ' ' +
                                                      val.last_name}
                                                  </TableCell>
                                                  <TableCell
                                                    className='remove-padding pucode'
                                                    align='right'
                                                    onClick={() =>
                                                      this.handleOpen(
                                                        'kiosk',
                                                        val
                                                      )
                                                    }>
                                                    {val.pucode}
                                                  </TableCell>
                                                  <TableCell
                                                    className='remove-padding'
                                                    align='right'>
                                                    {val.name}
                                                  </TableCell>
                                                  <TableCell
                                                    className='remove-padding'
                                                    align='right'>
                                                    {val.stock_code}
                                                  </TableCell>
                                                  <TableCell
                                                    className='remove-padding'
                                                    align='right'>
                                                    {val.type_id ===
                                                    DEVICE_TYPE.Ready
                                                      ? 'Ready'
                                                      : val.type_id ===
                                                        DEVICE_TYPE.Out_for_Delivery
                                                      ? 'Out for Delivery'
                                                      : val.type_id ===
                                                        DEVICE_TYPE.Arrived
                                                      ? 'Arrived'
                                                      : val.type_id ===
                                                        DEVICE_TYPE.Stocked
                                                      ? 'Stocked'
                                                      : val.type_id ===
                                                        DEVICE_TYPE.Return
                                                      ? 'Return'
                                                      : val.type_id ===
                                                        DEVICE_TYPE.Cancelled
                                                      ? 'Cancelled'
                                                      : val.type_id ===
                                                        DEVICE_TYPE.Completed
                                                      ? 'Completed'
                                                      : val.type_id ===
                                                        DEVICE_TYPE.Assigned
                                                      ? 'Assigned'
                                                      : ''}
                                                  </TableCell>
                                                </TableRow>
                                              );
                                            }
                                          )
                                        : ''}
                                    </TableBody>
                                  </Table>
                                </InfiniteScroll>
                              </div>
                            ) : (
                              <div
                                container
                                className='card-height noDataFound'>
                                <span>No Data Found</span>
                              </div>
                            )}
                          </div>
                        </div>
                      </Paper>
                    </Grid>
                  ) : (
                    ''
                  )}
                  {this.state.curbSideData &&
                  this.state.curbSideData.total > 0 ? (
                    <Grid
                      item
                      xs={4}
                      style={{
                        paddingRight: '10px',
                        paddingLeft: '30px',
                        paddingTop: '0px',
                      }}>
                      <Paper className={classes.paper}>
                        <div>
                          <Grid container>
                            <Grid item xs={8}>
                              <span className='pending curbside'>
                                Curb Side
                              </span>
                            </Grid>
                            <Grid item xs={2}>
                              <img
                                src={curbsideIcon}
                                alt='Icon'
                                className='pendingIcon'
                              />
                            </Grid>
                            <Grid item xs={2} className='count-position'>
                              <CardHeader
                                title={
                                  this.state.curbSideData &&
                                  this.state.curbSideData.total > 0
                                    ? this.state.curbSideData.total
                                    : 0
                                }
                              />
                            </Grid>
                          </Grid>
                          <div style={{ overflow: 'auto' }}>
                            <Table class='fixed_headers'>
                              <TableHead className='thead'>
                                <TableRow className='row-height'>
                                  <TableCell className='remove-padding full-name'>
                                    Full Name
                                  </TableCell>
                                  <TableCell
                                    className='remove-padding'
                                    align='right'>
                                    PU Code
                                  </TableCell>
                                  <TableCell
                                    className='remove-padding'
                                    align='right'
                                    style={{ width: '100px' }}>
                                    Storage Location
                                  </TableCell>
                                  <TableCell
                                    className='remove-padding'
                                    align='right'>
                                    Patient Notes
                                  </TableCell>
                                  <TableCell
                                    className='remove-padding'
                                    align='right'>
                                    Status
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                            </Table>
                            {this.state.curbSideData &&
                            this.state.curbSideData.total > 0 ? (
                              <div
                                scrollableTarget='scrollableDiv'
                                className='card-height'>
                                <InfiniteScroll
                                  dataLength={this.state.rowsPerPageCurbside}
                                  next={() => this.fetchMoreData('curbside')}
                                  hasMore={this.state.hasMoreCurbside}
                                  height={250}
                                  endMessage={
                                    <p style={{ textAlign: 'center' }}>
                                      <b>Yay! You have seen it all</b>
                                    </p>
                                  }>
                                  <Table style={{ tableLayout: 'fixed' }}>
                                    <TableBody className='tbody' style={{ height: '0px' }}>
                                      {this.state.curbSideData &&
                                      this.state.curbSideData.total > 0
                                        ? this.state.curbSideData.results.map(
                                            (val) => {
                                              let color =
                                                val.type_id &&
                                                val.type_id ===
                                                  DEVICE_TYPE.Arrived
                                                  ? `style-row`
                                                  : '';
                                              return (
                                                <TableRow
                                                  key={val.id}
                                                  className={`row-height ${color}`}>
                                                  <TableCell
                                                    component='th'
                                                    scope='row'
                                                    className='remove-padding'>
                                                    {val.first_name +
                                                      ' ' +
                                                      val.last_name}
                                                  </TableCell>
                                                  <TableCell
                                                    className='remove-padding pucode'
                                                    align='right'
                                                    onClick={() =>
                                                      this.handleOpen(
                                                        'curbside',
                                                        val
                                                      )
                                                    }>
                                                    {val.pucode}
                                                  </TableCell>
                                                  <TableCell
                                                    className='remove-padding'
                                                    align='right'>
                                                    {val.storage_location}
                                                  </TableCell>
                                                  <TableCell
                                                    className='remove-padding'
                                                    align='right'>
                                                    {val.notes}
                                                  </TableCell>
                                                  <TableCell
                                                    className='remove-padding'
                                                    align='right'>
                                                    {val.type_id ===
                                                    DEVICE_TYPE.Ready
                                                      ? 'Ready'
                                                      : val.type_id ===
                                                        DEVICE_TYPE.Out_for_Delivery
                                                      ? 'Out for Delivery'
                                                      : val.type_id ===
                                                        DEVICE_TYPE.Arrived
                                                      ? 'Arrived'
                                                      : val.type_id ===
                                                        DEVICE_TYPE.Stocked
                                                      ? 'Stocked'
                                                      : val.type_id ===
                                                        DEVICE_TYPE.Return
                                                      ? 'Return'
                                                      : val.type_id ===
                                                        DEVICE_TYPE.Cancelled
                                                      ? 'Cancelled'
                                                      : val.type_id ===
                                                        DEVICE_TYPE.Completed
                                                      ? 'Completed'
                                                      : ''}
                                                  </TableCell>
                                                </TableRow>
                                              );
                                            }
                                          )
                                        : ''}
                                    </TableBody>
                                  </Table>
                                </InfiniteScroll>
                              </div>
                            ) : (
                              <div
                                container
                                className='card-height noDataFound'>
                                <span>No Data Found</span>
                              </div>
                            )}
                          </div>
                        </div>
                      </Paper>
                    </Grid>
                  ) : (
                    ''
                  )}
                  {this.state.courierData &&
                  this.state.courierData.total > 0 ? (
                    <Grid
                      item
                      xs={4}
                      style={{
                        paddingRight: '10px',
                        paddingTop: '0px',
                        paddingLeft: '10px',
                      }}>
                      <Paper className={classes.paper}>
                        <div>
                          <Grid container>
                            <Grid item xs={8}>
                              <span className='pending courier'>Courier</span>
                            </Grid>
                            <Grid item xs={2}>
                              <img
                                src={courierIcon}
                                alt='Icon'
                                className='pendingIcon'
                              />
                            </Grid>
                            <Grid item xs={2} className='count-position'>
                              <CardHeader
                                title={
                                  this.state.courierData &&
                                  this.state.courierData.total > 0
                                    ? this.state.courierData.total
                                    : 0
                                }
                              />
                            </Grid>
                          </Grid>
                          <div style={{ overflow: 'auto' }}>
                            <Table class='fixed_headers'>
                              <TableHead className='thead'>
                                <TableRow className='row-height'>
                                  <TableCell className='remove-padding full-name'>
                                    Full Name
                                  </TableCell>
                                  <TableCell
                                    className='remove-padding'
                                    align='right'>
                                    PU Code
                                  </TableCell>
                                  <TableCell
                                    className='remove-padding'
                                    align='right'>
                                    Source Location
                                  </TableCell>
                                  <TableCell
                                    className='remove-padding'
                                    align='right'>
                                    Destination Location
                                  </TableCell>
                                  <TableCell
                                    className='remove-padding'
                                    align='right'>
                                    Status
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                            </Table>
                            {this.state.courierData &&
                            this.state.courierData.total > 0 ? (
                              <div
                                scrollableTarget='scrollableDiv'
                                className='card-height'>
                                <InfiniteScroll
                                  dataLength={this.state.rowsPerPageCourier}
                                  next={() => this.fetchMoreData('courier')}
                                  hasMore={this.state.hasMoreCourier}
                                  height={250}
                                  endMessage={
                                    <p style={{ textAlign: 'center' }}>
                                      <b>Yay! You have seen it all</b>
                                    </p>
                                  }>
                                  <Table style={{ tableLayout: 'fixed' }}>
                                    <TableBody className='tbody' style={{ height: '0px' }}>
                                      {this.state.courierData &&
                                      this.state.courierData.total > 0
                                        ? this.state.courierData.results.map(
                                            (val) => {
                                              return (
                                                <TableRow
                                                  key={val.id}
                                                  className='row-height'>
                                                  <TableCell
                                                    component='th'
                                                    scope='row'
                                                    className='remove-padding'>
                                                    {val.first_name +
                                                      ' ' +
                                                      val.last_name}
                                                  </TableCell>
                                                  <TableCell
                                                    className='remove-padding pucode'
                                                    align='right'
                                                    onClick={() =>
                                                      this.handleOpen(
                                                        'courier',
                                                        val
                                                      )
                                                    }>
                                                    {val.pucode}
                                                  </TableCell>
                                                  <TableCell
                                                    className='remove-padding'
                                                    align='right'>
                                                    {val.source_location}
                                                  </TableCell>
                                                  <TableCell
                                                    className='remove-padding'
                                                    align='right'>
                                                    {val.destination_location}
                                                  </TableCell>
                                                  <TableCell
                                                    className='remove-padding'
                                                    align='right'>
                                                    {val.type_id ===
                                                    DEVICE_TYPE.Ready
                                                      ? 'Ready'
                                                      : val.type_id ===
                                                        DEVICE_TYPE.Out_for_Delivery
                                                      ? 'Out for Delivery'
                                                      : val.type_id ===
                                                        DEVICE_TYPE.Arrived
                                                      ? 'Arrived'
                                                      : val.type_id ===
                                                        DEVICE_TYPE.Stocked
                                                      ? 'Stocked'
                                                      : val.type_id ===
                                                        DEVICE_TYPE.Return
                                                      ? 'Return'
                                                      : val.type_id ===
                                                        DEVICE_TYPE.Cancelled
                                                      ? 'Cancelled'
                                                      : val.type_id ===
                                                        DEVICE_TYPE.Completed
                                                      ? 'Completed'
                                                      : ''}
                                                  </TableCell>
                                                </TableRow>
                                              );
                                            }
                                          )
                                        : ''}
                                    </TableBody>
                                  </Table>
                                </InfiniteScroll>
                              </div>
                            ) : (
                              <div
                                container
                                className='card-height noDataFound'>
                                <span>No Data Found</span>
                              </div>
                            )}
                          </div>
                        </div>
                      </Paper>
                    </Grid>
                  ) : (
                    ''
                  )}
                  {this.state.bedSideData &&
                  this.state.bedSideData.total > 0 ? (
                    <Grid
                      item
                      xs={4}
                      style={{
                        paddingRight: '10px',
                        paddingLeft: '10px',
                        paddingTop: '10px',
                      }}>
                      <Paper className={classes.paper}>
                        <div>
                          <Grid container>
                            <Grid item xs={8}>
                              <span className='pending bedside'>Bedside</span>
                            </Grid>
                            <Grid item xs={2}>
                              <img
                                src={bedsideIcon}
                                alt='Icon'
                                className='pendingIcon'
                              />
                            </Grid>
                            <Grid item xs={2} className='count-position'>
                              <CardHeader
                                title={
                                  this.state.bedSideData &&
                                  this.state.bedSideData.total > 0
                                    ? this.state.bedSideData.total
                                    : 0
                                }
                              />
                            </Grid>
                          </Grid>
                          <div style={{ overflow: 'auto' }}>
                            <Table class='fixed_headers'>
                              <TableHead className='thead'>
                                <TableRow className='row-height'>
                                  <TableCell className='remove-padding full-name'>
                                    Full Name
                                  </TableCell>
                                  <TableCell
                                    className='remove-padding'
                                    align='right'>
                                    PU Code
                                  </TableCell>
                                  <TableCell
                                    className='remove-padding'
                                    align='right'>
                                    Location Notes
                                  </TableCell>
                                  <TableCell
                                    className='remove-padding'
                                    align='right'>
                                    Room No and Bed No
                                  </TableCell>
                                  <TableCell
                                    className='remove-padding'
                                    align='right'>
                                    Status
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                            </Table>
                            {this.state.bedSideData &&
                            this.state.bedSideData.total > 0 ? (
                              <div
                                scrollableTarget='scrollableDiv'
                                className='card-height'>
                                <InfiniteScroll
                                  dataLength={this.state.rowPerPageInPatient}
                                  next={() => this.fetchMoreData('inpatient')}
                                  hasMore={this.state.hasMoreInpatient}
                                  height={250}
                                  endMessage={
                                    <p style={{ textAlign: 'center' }}>
                                      <b>Yay! You have seen it all</b>
                                    </p>
                                  }>
                                  <Table style={{ tableLayout: 'fixed' }}>
                                    <TableBody className='tbody' style={{ height: '0px' }}>
                                      {this.state.bedSideData &&
                                      this.state.bedSideData.total > 0
                                        ? this.state.bedSideData.results.map(
                                            (val) => {
                                              return (
                                                <TableRow
                                                  key={val.id}
                                                  className='row-height'>
                                                  <TableCell
                                                    component='th'
                                                    scope='row'
                                                    className='remove-padding'>
                                                    {val.first_name +
                                                      ' ' +
                                                      val.last_name}
                                                  </TableCell>
                                                  <TableCell
                                                    className='remove-padding pucode'
                                                    align='right'
                                                    onClick={() =>
                                                      this.handleOpen(
                                                        'bedside',
                                                        val
                                                      )
                                                    }>
                                                    {val.pucode}
                                                  </TableCell>
                                                  <TableCell
                                                    className='remove-padding'
                                                    align='right'>
                                                    {val.notes}
                                                  </TableCell>
                                                  <TableCell
                                                    className='remove-padding'
                                                    align='right'>
                                                    {val.room_no &&
                                                      val.room_no !== 'null' &&
                                                      val.bed_no}
                                                    {val.bed_no &&
                                                      val.bed_no !== 'null' &&
                                                      '/' + val.bed_no}
                                                  </TableCell>
                                                  <TableCell
                                                    className='remove-padding'
                                                    align='right'>
                                                    {val.type_id ===
                                                    DEVICE_TYPE.Ready
                                                      ? 'Ready'
                                                      : val.type_id ===
                                                        DEVICE_TYPE.Out_for_Delivery
                                                      ? 'Out for Delivery'
                                                      : val.type_id ===
                                                        DEVICE_TYPE.Arrived
                                                      ? 'Arrived'
                                                      : val.type_id ===
                                                        DEVICE_TYPE.Stocked
                                                      ? 'Stocked'
                                                      : val.type_id ===
                                                        DEVICE_TYPE.Return
                                                      ? 'Return'
                                                      : val.type_id ===
                                                        DEVICE_TYPE.Cancelled
                                                      ? 'Cancelled'
                                                      : val.type_id ===
                                                        DEVICE_TYPE.Completed
                                                      ? 'Completed'
                                                      : ''}
                                                  </TableCell>
                                                </TableRow>
                                              );
                                            }
                                          )
                                        : ''}
                                    </TableBody>
                                  </Table>
                                </InfiniteScroll>
                              </div>
                            ) : (
                              <div
                                container
                                className='card-height noDataFound'>
                                <span>No Data Found</span>
                              </div>
                            )}
                          </div>
                        </div>
                      </Paper>
                    </Grid>
                  ) : (
                    ''
                  )}
                </Grid>
              </Grid>
              <Grid
                item
                xs={3}
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  padding: '0px 15px',
                }}>
                <div>
                  <Calendar value={new Date()} />
                  <Paper>
                    <List dense={false}>
                      <ListItem style={{ borderBottom: '1px solid #ccc' }}>
                        <ListItemAvatar
                          style={{ borderRight: '12px solid #269CCC' }}>
                          3:30 PM&nbsp;
                        </ListItemAvatar>
                        <ListItemText primary='&nbsp;Invitation for Telahealth visit' />
                      </ListItem>
                      <ListItem style={{ borderBottom: '1px solid #ccc' }}>
                        <ListItemAvatar
                          style={{ borderRight: '12px solid #55B78C' }}>
                          4:00 PM&nbsp;
                        </ListItemAvatar>
                        <ListItemText primary='&nbsp;Reminder for John Doe visit' />
                      </ListItem>
                      <ListItem style={{ borderBottom: '1px solid #ccc' }}>
                        <ListItemAvatar
                          style={{ borderRight: '12px solid #334C8E' }}>
                          5:00 PM&nbsp;
                        </ListItemAvatar>
                        <ListItemText primary='&nbsp;Scheuled visit with Mr. Sam Wilsons' />
                      </ListItem>
                    </List>
                  </Paper>
                  {/* <ChatScreen></ChatScreen> */}
                </div>
              </Grid>
            </Grid>
          </div>
          </div>
        </div>
        <div id='isprint'>
            <PrintTemplate>
              <LabelTemplate
                style={{ display: 'none' }}
                stockCode={this.state.popupData.stock_code || ''}
                pickupCode={this.state.popupData.pucode || ''}
                rxNumbers={
                  this.state.popupData &&
                  this.state.popupData.items &&
                  this.state.popupData.items.length > 0 &&
                  this.state.popupData.items.map((item) => {
                    return item.rx_no;
                  })
                }
                boxId={this.state.popupData.box_id || ''}
                ref={(el) => (this.componentRef = el)}
                accountDetails={this.state.popupData.accDetails || ''}
                pharmacyDetails={this.state.popupData.boxDetails || ''}
                firstName={this.state.popupData.first_name || ''}
                lastName={this.state.popupData.last_name || ''}
                prefer_location_name={this.state.popupData.box_name || ''}
              />
            </PrintTemplate>
          </div>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(Console);



// WEBPACK FOOTER //
// ./src/components/console/index.js